import { queryUserInfo } from "@/api/basicInfo";
import { pageListUserlnfoForAudit } from "@/api/user";
export default {
  data() {
    return {
      currentCompany: [], // 当前公司
      groupCompany: [], // 集团总公司
      isSubmitApproval: 0 // 0 否 1 是
    };
  },
  methods: {
    async queryList() {
      await this.getCurrentCompany();
      await this.getGroupCompany();
    },
    async getGroupCompany() {
      const {
        result: { records },
        code,
      } = await pageListUserlnfoForAudit({
        pageNum: 1,
        pageSize: 9999,
        companyName: process.env.VUE_APP_COMPANY_NAME,
      });
      if (code === 0) {
        this.groupCompany = records;
      }
    },
    async getCurrentCompany() {
      let currentCompanyItem = JSON.parse(this.$base.getLocalStorage('current_company'))
      let currentCompanyId = currentCompanyItem.companyId;
      const {
        result: { records },
        code,
      } = await queryUserInfo({
        pageNum: 1,
        pageSize: 9999,
        companyId: currentCompanyId,
        enableStatus: 1
      });
      if (code === 0) {
        this.currentCompany = records;
      }
    },
  },
  computed: {
    userInfoList() {
      return this.isSubmitApproval === 0 ? this.currentCompany : this.groupCompany
    }
  },
  watch: {
    show: {
      handler(isShow) {
        if (!isShow) {
          this.isSubmitApproval = 0
        }
      }
    },
    dialogFormVisible: {
      handler(isShow) {
        if (!isShow) {
          this.isSubmitApproval = 0
        }
      }
    },
    isSubmitApproval() {
      if (this.addForm) {
        this.addForm.auditPersonId = ''
        this.addForm.nextAuditUserName = ''
      }
      if (this.applyInfo) {
        this.applyInfo.auditPersonId = ''
        this.applyInfo.nextAuditUserName = ''
      }
      if (this.addInfo) {
        this.addInfo.auditPersonId = ''
        this.addInfo.nextAuditUserName = ''
      }
      if (this.info) {
        this.info.auditPersonId = ''
        this.info.nextAuditUserName = ''
      }
    },
    // type(val) {
    //   console.log(val);
    //   this.applyInfo.auditPersonId = ''
    //   console.log(this.applyInfo);
    //   if (val === 'new' && this.addForm && this.addForm.auditPersonId) {
    //     this.addForm.auditPersonId = ''
    //   }
    //   // if (val === 'new' && this.applyInfo && this.applyInfo.auditPersonId) {
    //   //   this.applyInfo.auditPersonId = ''
    //   // }
    //   if (val === 'new' && this.addInfo && this.addInfo.auditPersonId) {
    //     this.addInfo.auditPersonId = ''
    //   }
    //   if (val === 'new' && this.info && this.info.auditPersonId) {
    //     this.info.auditPersonId = ''
    //   }
    // }
  }
};
